import createIcon from '../../createIcon';

/**
 * @component @name BedroomChild
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgOC41SDlWMTAuNUgxNVY4LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTUuNjQgMTJIOC4zN0M3Ljg5IDEyIDcuNSAxMi4zOSA3LjUgMTIuODdINy41MVYxNEgxNi41MVYxMi44N0MxNi41MSAxMi4zOSAxNi4xMiAxMiAxNS42NCAxMloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMCAySDRDMi45IDIgMiAyLjkgMiA0VjIwQzIgMjEuMSAyLjkgMjIgNCAyMkgyMEMyMS4xIDIyIDIyIDIxLjEgMjIgMjBWNEMyMiAyLjkgMjEuMSAyIDIwIDJaTTE4IDE3SDE2LjVWMTUuNUg3LjVWMTdINlYxMi44N0M2IDExLjg3IDYuNjIgMTEuMDIgNy41IDEwLjY3VjlDNy41IDcuOSA4LjQgNyA5LjUgN0gxNC41QzE1LjYgNyAxNi41IDcuOSAxNi41IDlWMTAuNjdDMTcuMzggMTEuMDIgMTggMTEuODcgMTggMTIuODdWMTdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BedroomChild = createIcon('BedroomChild', [
  ['path', { d: 'M15 8.5H9V10.5H15V8.5Z', key: '6p0380' }],
  [
    'path',
    {
      d: 'M15.64 12H8.37C7.89 12 7.5 12.39 7.5 12.87H7.51V14H16.51V12.87C16.51 12.39 16.12 12 15.64 12Z',
      key: '17fh97',
    },
  ],
  [
    'path',
    {
      d: 'M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM18 17H16.5V15.5H7.5V17H6V12.87C6 11.87 6.62 11.02 7.5 10.67V9C7.5 7.9 8.4 7 9.5 7H14.5C15.6 7 16.5 7.9 16.5 9V10.67C17.38 11.02 18 11.87 18 12.87V17Z',
      key: '4dgxzy',
    },
  ],
]);

export default BedroomChild;
